import { Divider, type DividerProps } from "@mantine/core";
import { forwardRef } from "react";
import classes from "./separators.module.css";

export const ListItemSeparator = forwardRef<HTMLDivElement, DividerProps>(function ListItemSeparator(props, ref) {
    return (
        <Divider
            classNames={{
                label: classes.dividerLabel,
            }}
            size="sm"
            mt="lg"
            mb="lg"
            ref={ref}
            {...props}
        />
    );
});
